module.exports = __webpack_public_path__ + "img/line-qr-code.34d2ac7c.png";